import React, { useEffect, useState } from 'react';
import Layout from "../components/Layout";

const Fleet = ({ initialLocation = 'Kelowna' }) => {
    const [cars, setCars] = useState([]);
    const backendBaseUrl = 'https://api.karrentals.ca';
    const [currentLocation, setCurrentLocation] = useState(initialLocation);

    useEffect(() => {
        document.title = "Our Fleet | KAR – Kelowna Auto Rentals";
        document.querySelector('meta[name="description"]')?.setAttribute("content",
            "Browse KAR's premium fleet — Corvette Stingray, Tesla Model 3, Ford Raptor, Bronco & more. Available in Kelowna and Vancouver. Book online today."
        );
    }, []);

    useEffect(() => {
        const fetchCarsAndPhotos = async () => {
            try {
                const carsResponse = await fetch(`${backendBaseUrl}/fetch-cars?location=${currentLocation}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                if (!carsResponse.ok) {
                    throw new Error("Failed to fetch cars");
                }
                const carsData = await carsResponse.json();

                const photosResponse = await fetch(`${backendBaseUrl}/primary-photos`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                if (!photosResponse.ok) {
                    throw new Error("Failed to fetch photos");
                }
                const photosData = await photosResponse.json();

                // Merge cars with their primary photos
                const carsWithPhotos = carsData.cars.map(car => ({
                    ...car,
                    photo: photosData.data.find(photo => photo.car_id === car.id)?.primary_photo_url || '/default-car.jpg'
                }));

                setCars(carsWithPhotos);
            } catch (error) {
                console.error('Error fetching cars and photos:', error);
            }
        };

        fetchCarsAndPhotos();
    }, [currentLocation]); // refetch when location changes

    return (
        <Layout>
            <div className="container mx-auto p-6">
                <h1 className="text-3xl font-bold text-center mb-6">Our Fleet</h1>
                <div className="container mx-auto flex justify-start px-2 pt-2 my-4">
                    <button
                        className={`px-6 py-2 rounded-full font-semibold ${
                            currentLocation === 'Kelowna' ? 'bg-white text-black' : 'bg-customGray text-black'
                        }`}
                        onClick={() => setCurrentLocation('Kelowna')}
                    >
                        Kelowna <span className="font-light">YLW</span>
                    </button>
                    <button
                        className={`mx-2 px-6 py-2 rounded-full font-semibold ${
                            currentLocation === 'Vancouver' ? 'bg-white text-black' : 'bg-customGray text-black'
                        }`}
                        onClick={() => setCurrentLocation('Vancouver')}
                    >
                        Vancouver <span className="font-light">YVR</span>
                    </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                    {cars.map(car => (
                        <div key={car.id} className="shadow-lg rounded-lg">
                            <img src={car.photo} alt={car.name} className="w-full h-60 object-cover rounded-t-lg" />
                            <div className="p-4">
                                <h2 className="text-xl font-semibold">{car.year} {car.name} {car.model}</h2>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default Fleet;
